import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  outage: boolean = true;
  release: boolean = false;
  constructor() {}
}
